const autoNgTemplateLoaderTemplate1 = require('./host-view.html');

angular.module('portainer.docker').component('hostView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'HostViewController',
});
